import { initCatalog } from '../../../ci/catalog/index.js?vue3';

initCatalog();
